import { getEnvVariable } from '../../modules/environmentalList';

export function sanitizeKeyFragment(value) {
  return (value || '').toString().replace(/[^a-zA-Z0-9]/g, '');
}

export function portalPrefixFromChar(portal) {
  if (portal === 'I') return 'internaltoken';
  if (portal === 'E') return 'externaltoken';
  return 'internaltoken';
}

export function getTokenStorageKey(portalChar) {
  const base = portalPrefixFromChar(portalChar || getEnvVariable('AccessPortal'));
  const moduleKey = sanitizeKeyFragment(getEnvVariable('ModuleKey') || '');
  const titleKey = sanitizeKeyFragment(getEnvVariable('TitleKey') || '');
  return `${base}_${moduleKey}_${titleKey}`;
}

export default getTokenStorageKey;
